import { useEffect, type ReactNode } from 'react';
import { SBubbleWrapper, SBubbleText, SBubbleIcon } from './NotificationBubble.styles';

type INotificationBubbleProps = {
  notification?: number | '!';
  icon?: ReactNode;
  isDanger?: boolean;
  className?: string;
  skipEntrance?: boolean;
  onEntranceComplete?: () => void;
};

export const NotificationBubble = ({
  notification,
  icon,
  isDanger = false,
  className = '',
  skipEntrance = true,
  onEntranceComplete,
}: INotificationBubbleProps) => {
  const animate = !skipEntrance;

  useEffect(() => {
    if (!animate) return;
    if (typeof window === 'undefined' || !('matchMedia' in window)) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (mq.matches) onEntranceComplete?.();
  }, [animate, onEntranceComplete]);

  if (!icon && notification === undefined) return null;

  const text =
    !icon && typeof notification === 'number' && notification > 99
      ? '99+'
      : String(notification ?? '');

  return (
    <SBubbleWrapper
      isDanger={isDanger}
      $animate={animate}
      className={className}
      role="notificationBubble"
      onAnimationEnd={animate ? onEntranceComplete : undefined}
    >
      {icon ? (
        <SBubbleIcon role="content">{icon}</SBubbleIcon>
      ) : (
        <SBubbleText role="content">{text}</SBubbleText>
      )}
    </SBubbleWrapper>
  );
};
